import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-06abe11d"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "container" };
const _hoisted_2 = { class: "row productOverview bg-white" };
const _hoisted_3 = { class: "col-12 col-md-6" };
const _hoisted_4 = { class: "shoppingList my-1" };
const _hoisted_5 = { class: "shoppingListProduct col-12 pt-1 pb-1" };
const _hoisted_6 = {
    key: 0,
    class: "row"
};
const _hoisted_7 = { class: "col-2 col-md-1 pr-0 pl-0 text-center" };
const _hoisted_8 = ["src", "alt"];
const _hoisted_9 = {
    class: "col-10 col-md-11 pt-0 pt-md-1",
    style: { "line-height": "1.2rem" }
};
const _hoisted_10 = { class: "font7 strong" };
const _hoisted_11 = { class: "col-12 col-md-6" };
const _hoisted_12 = { class: "shoppingList" };
const _hoisted_13 = { key: 0 };
const _hoisted_14 = {
    onclick: "$('.JS_blueCartButton').click()",
    style: { "cursor": "pointer" }
};
const _hoisted_15 = { class: "shoppingListProduct col-12 pt-1 pt-md-2 pb-1 pl-0" };
const _hoisted_16 = { class: "row" };
const _hoisted_17 = { class: "col-12 font7" };
const _hoisted_18 = {
    key: 0,
    class: "pl-1"
};
const _hoisted_19 = {
    key: 1,
    class: "pl-1"
};
const _hoisted_20 = { class: "col-12 pt-1 pb-1" };
const _hoisted_21 = { class: "row" };
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", {
    title: "Übersicht meiner Verkaufsprodukte",
    class: "float-right link-in-text font7 text-underline [ JS_blueCartButton JS_header_toggle_interactive ]"
}, [
    /*#__PURE__*/ _createElementVNode("i", { class: "icon-agb" }),
    /*#__PURE__*/ _createTextVNode(" Zur Übersicht ")
], -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_formatted_price = _resolveComponent("formatted-price");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("ul", _hoisted_4, [
                    _createElementVNode("li", null, [
                        _createElementVNode("div", _hoisted_5, [
                            (_ctx.first_product)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                    _createElementVNode("div", _hoisted_7, [
                                        _createElementVNode("img", {
                                            class: "shoppingListProduct-img",
                                            src: _ctx.first_product.image,
                                            alt: _ctx.first_product.name
                                        }, null, 8, _hoisted_8)
                                    ]),
                                    _createElementVNode("div", _hoisted_9, [
                                        _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.first_product.name), 1)
                                    ])
                                ]))
                                : _createCommentVNode("", true)
                        ])
                    ])
                ])
            ]),
            _createElementVNode("div", _hoisted_11, [
                _createElementVNode("ul", _hoisted_12, [
                    (_ctx.count_total > 1)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_13, [
                            _createElementVNode("div", _hoisted_14, [
                                _createElementVNode("div", _hoisted_15, [
                                    _createElementVNode("div", _hoisted_16, [
                                        _createElementVNode("div", _hoisted_17, [
                                            _createTextVNode(" ...und noch "),
                                            _createElementVNode("strong", null, _toDisplayString(_ctx.count_total - 1), 1),
                                            (_ctx.count_total === 2)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_18, "weiteres Produkt"))
                                                : (_ctx.count_total > 2)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_19, "weitere Produkte"))
                                                    : _createCommentVNode("", true)
                                        ])
                                    ])
                                ])
                            ])
                        ]))
                        : _createCommentVNode("", true),
                    _createElementVNode("li", null, [
                        _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("div", _hoisted_21, [
                                _createElementVNode("div", {
                                    class: _normalizeClass(["col-12 font7 px-0", _ctx.count_total >= 2 ? 'mt-0' : 'mt-2'])
                                }, [
                                    _createTextVNode(" Gesamt: "),
                                    _createVNode(_component_formatted_price, {
                                        class: "strong",
                                        price: _ctx.total_costs
                                    }, null, 8, ["price"]),
                                    _hoisted_22
                                ], 2)
                            ])
                        ])
                    ])
                ])
            ])
        ])
    ]));
}
